import { render, staticRenderFns } from "./InvoiceRefundTable.vue?vue&type=template&id=1368c470&scoped=true&"
import script from "./InvoiceRefundTable.vue?vue&type=script&lang=js&"
export * from "./InvoiceRefundTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1368c470",
  null
  
)

export default component.exports